module.exports = __webpack_public_path__ + "img/customer.60b7a1db.png";